'use client';

import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';
import { Election } from '~/definitions/election';
import Button from '~/components/Button/Button';
import Heading from '~/components/Heading/Heading';
import { FREETEXT_KEYS } from '~/const/freetext';
import SafeHTML from '~/components/SafeHTML/SafeHTML';

type Props = {
    election?: Election;
    onClickSeeCandidates: () => void;
    freetextBallotTitle: string;
    btnSeeCandidatesText: string;
};

const Intro = (props: Readonly<Props>) => {
    const { election, onClickSeeCandidates, freetextBallotTitle, btnSeeCandidatesText } = props;

    const descClassName = 'description';
    const detailClassName = 'detail';

    return (
        <div className="intro">
            <div className="info px-[15px] pb-[30px]">
                <Heading
                    title={freetextBallotTitle}
                    electionLogoUrl={election?.electionLogoUrl || ''}
                    extendedClassName="mdLandscape:text-[3.25em]"
                />
                <SafeHTML className={descClassName} html={election?.electionDescription ?? ''} />
                <div className="my-[30px] w-full text-center">
                    <Button
                        btnText={btnSeeCandidatesText}
                        testId={'btn-see-candidate'}
                        extendedClassName="w-full md:max-w-[300px]"
                        onClick={onClickSeeCandidates}
                    />
                </div>
                <SafeHTML className={detailClassName} html={election?.electionAnnualDescription ?? ''} />
            </div>
        </div>
    );
};

const IntroWithStore = observer(() => {
    const { ballotStore, freetextStore } = getStore();

    const election = ballotStore.election;
    const freetextBallotTitle = freetextStore.getFreetextValueByKey(FREETEXT_KEYS.ballot_title);
    const btnSeeCandidatesText = freetextStore.getFreetextValueByKey(FREETEXT_KEYS.btn_see_candidates);

    return (
        <Intro
            election={election}
            onClickSeeCandidates={ballotStore.onClickSeeCandidates}
            freetextBallotTitle={freetextBallotTitle}
            btnSeeCandidatesText={btnSeeCandidatesText}
        />
    );
});

export default IntroWithStore;
